import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Iplus } from 'agrofy-ui-components';
import { useTranslation } from 'react-i18next';
import TagManager from 'react-gtm-module';
import './DailyWeather.scss';

export const DailyWeather = ({weatherData, weatherDaysToDisplay = 3, weatherShowSponsoredBy,weatherShowSponsoredByBR}) => {
  const { t } = useTranslation(['translation', 'links']);
  const loader = (
    <div className="loader container pr-0 min-height">
      <div className="animated-background" />
    </div>
  );
  const [isLoading, setIsLoading] = useState(true);

  const countryName = process.env.COUNTRY_NAME || window.env.COUNTRY_NAME;
  const isBrasil = countryName === 'Brasil';
  const showSponsoredBy = isBrasil ? weatherShowSponsoredByBR : weatherShowSponsoredBy;
  const weatherLink = isBrasil ? '/previsao-clima-tempo/7-dias' : '/pronostico-clima-tiempo/7-dias';

  useEffect(() => {
    setIsLoading(!weatherData);
  }, [weatherData]);

  const manageGTM = () => {
    const tagManagerArgs = {
      dataLayer: {
        event: 'trackEvent',
        eventCategory: 'Navigation',
        eventAction: 'Agrofy News - Indicadores Home',
        eventLabel: 'Clima',
      },
    };
    TagManager.dataLayer(tagManagerArgs);
  };

  return (
    <a
      href={weatherLink}
      onClick={() => manageGTM()}
    >
      {isLoading ? (
        loader
      ) : (
        <React.Fragment>
          <div className={`component daily-weather ${showSponsoredBy ? 'show-sponsored' : ''}`}>
          {showSponsoredBy && (
            <div className="sponsored-by">
              <span className="sponsored-by-text">{t('sponsored-by')}</span>
              {isBrasil ? 
                <img alt="Incomagri" src="https://news.agrofystatic.com/sponsor-incomagri.png?d=54x14" width={54} height={14}/>
                : 
                <img alt="Agroterrum" src="https://news.agrofystatic.com/logo-agroterrum.png?d=95x15" width={95} height={15}/>
              }
            </div>
          )}            
            <div className={'daily-item clima'}>
              <ul>
                <li>
                  <div className="tituloClima">
                    <h6>{t('translation:today')}</h6>
                    <img className='temp-icon' src='https://news.agrofystatic.com/clima/ico-temperature.png?d=20x20' alt='temp' />
                  </div>
                  <label>Temp: {weatherData.temp_min}° / {weatherData.temp_max}°</label>
                  <label>Sens: {weatherData.feels_like_min}° / {weatherData.feels_like_max}°</label>
                </li>
                <li>
                  <div className="tituloClima">
                    <h6>{t('rains')}</h6>
                    <i className="clima-icon main-icon icon-18"></i>
                  </div>
                  <label>Semana: {weatherData.weekly_rainfall}mm</label>
                  <label> 
                    {t(`months.${weatherData.month_name}`)}: {weatherData.monthly_rainfall}mm
                  </label>
                </li>
                <li>
                  <Iplus height='40px' width='40px' fill='#0067A0' />
                </li>
              </ul>
            </div>
            <div className="powered-by">
              <div className="powered-by-left">
                { weatherData.location }
              </div>
              <div className="powered-by-right">
                <span className="sponsored-by-text">Powered by</span>
                <img alt="Ignitia" src="https://news.agrofystatic.com/logo-ignitia.png?d=38x15" width={38} height={15}/>
              </div>
            </div>
          </div>
        </React.Fragment>
      )}
    </a>
  );
};

export default DailyWeather;
